import React, { useEffect, useState } from "react";
import { Table, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getRequest, deleteRequest, postRequest } from "api";
import { TableHeader } from "components";
import Spinner from "components/Spinner";
import { errorMsg, successMsg } from "utils/msg";
import { useSearchParams } from "react-router-dom";
import getColumnSearchProps from "components/common/getColumnSearchProps";

function CustomTable({
  title,
  columns,
  endpoints,
  endpoint, //! used for delete, edit req
  primaryKey, //! used for delete, edit req
  refresh,
  noFilter = false, //! pass filter in req body
  addFunc,
  setRefresh,
  deleteFunc,
  onEdit, //! function
  data, //! used in special cases to get data from outside
  actionCol = true, //! үйлдэл btns
  rightBtn, //! used in special cases to show whatever btn inside table title (zms, hur - refreshDataBtn)
  resObj = false, //! to show object response inside table {} => [{}]
  isPost = false, //! request method
  filters,
  pagination = true,
  isAdd = true, //! show add btn
  isDelete = true, //! show delete btn
  isEdit = true, //! show edit btn
  setData, //! used in special cases to get res.data.Data inside component
  spinner = true, //! show spinner
  limit,
  ...props
}) {
  const [tableColumns, setColumns] = useState([]);
  const [state, setState] = useState({
    data: [],
    total: 0,
    loading: false,
    filter: {
      Offset: 0,
      Limit: limit || 50,
    },
  });
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  const handleChange = (pagination, filters) => {
    const tmpFilter = {};
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== null) {
        if (key === "rngtransdate") {
          tmpFilter["BeginTransDate"] = filters[key][0];
          tmpFilter["EndTransDate"] = filters[key][1];
        } else if (key === "rngdate") {
          tmpFilter["BeginDate"] = filters[key][0];
          tmpFilter["EndDate"] = filters[key][1];
        } else if (key === "rngnumber") {
          tmpFilter["MinAmount"] = filters[key][0];
          tmpFilter["MaxAmount"] = filters[key][1];
        } else {
          tmpFilter[key] = filters[key][0];
        }
      }
    });

    setState({
      ...state,
      filter: {
        ...tmpFilter,
        Limit: pagination.pageSize,
        Offset: pagination.current === 0 ? 0 : (pagination.current - 1) * pagination.pageSize,
      },
    });

    setSearchParams({
      ...tmpFilter,
      Offset: pagination.current === 0 ? 0 : (pagination.current - 1) * pagination.pageSize,
      Limit: pagination.pageSize,
    });
  };

  const fetchData = async () => {
    //! get searchParams to set filters inside request body when browser refreshing
    var params = {};
    searchParams.forEach((value, key) => {
      if (key === "Offset" || key === "Limit") {
        params[key] = +value;
      } else if (value === "true") {
        params[key] = true;
      } else if (value === "false") {
        params[key] = false;
      } else if (key === "tab") {
        //! do nothing, trick
      } else {
        params[key] = value;
      }
    });

    //     setState({...state, filter: {
    //       ...state.filter,
    // ...params
    //     }})

    try {
      setState({
        ...state,
        loading: true,
      });

      if (data !== undefined && data !== null) {
        setState({
          ...state,
          data: data,
          loading: false,
          total: data.length,
        });
      } else {
        if (isPost) {
          const res = await postRequest(endpoints || "", {
            //! please don't change positions
            ...params,
            ...filters,
            ...state.filter,
            Limit: limit || state.filter.Limit,
          });

          setState({
            ...state,
            data: resObj ? [{ ...res.data }] : res.data?.Data ?? [],
            loading: false,
            total: +res.data?.RowCount ?? res.data?.Data?.length ?? 0,
          });
          setData && setData(res.data?.Data);
        } else {
          const res = await getRequest(endpoints || "", {
            ...filters,
            // ...state.filter,
          });

          setState({
            ...state,
            data: resObj ? [res.data] : res.data?.Data ?? [],
            total: +res.data?.RowCount ?? res.data?.Data?.length ?? 0,
            loading: false,
          });
          setData && setData(res.data?.Data);
        }
      }
      // if (data !== undefined) {
      //   setState({
      //     ...state,
      //     data: data.results,
      //     total: data.results.length,
      //     loading: false,
      //   });
      // }
      // if (noFilter) {
      //   setState({
      //     ...state,
      //     data: res.data,
      //     loading: false,
      //   });
      // } else {
      //   setState({
      //     ...state,
      //     data: res.data,
      //     total: res.data.length,
      //     loading: false,
      //   });
      // }
    } catch (error) {
      errorMsg(error?.Msg);
      setState({
        ...state,
        loading: false,
      });
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [state.filter, refresh, endpoints]);

  useEffect(() => {
    const mergedColumns = columns.map((col) => {
      const colFilter = col.filter
        ? getColumnSearchProps({
            ...col.filter,
            value:
              searchParams.get(col.dataIndex) === "true"
                ? true
                : searchParams.get(col.dataIndex) === "false"
                ? false
                : searchParams.get(col.dataIndex),
            //! get searchParams to set filters inside request body when browser refreshing, string to boolean
          })
        : null;

      return {
        key: col.dataIndex,
        align: "center",
        render: (val) => <div style={{ textAlign: col.textAlign ?? "left" }}>{val}</div>,
        ...(searchParams.get(col.dataIndex) && {
          filteredValue: [
            searchParams.get(col.dataIndex) === "true"
              ? true
              : searchParams.get(col.dataIndex) === "false"
              ? false
              : searchParams.get(col.dataIndex),
          ],
        }),
        ...colFilter,
        ...col,
      };
    });
    setColumns(mergedColumns);

    // eslint-disable-next-line
  }, [searchParams]);

  const handleDelete = async (record) => {
    try {
      await deleteRequest(`${endpoint}/${record[primaryKey]}`);
      successMsg("Мэдээллийг амжилттай устгалаа.");
      setRefresh !== undefined && setRefresh();
      fetchData();
    } catch (error) {
      errorMsg(error?.Msg);
    }
  };

  const actionCols = {
    title: "Үйлдэл",
    dataIndex: "operation",
    align: "center",
    width: "80px",
    render: (_, record) => {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-evenly",
          }}
        >
          {isEdit && (
            <div
              onClick={
                onEdit
                  ? () => {
                      onEdit(record[primaryKey]);
                    }
                  : () => {
                      navigate(`${endpoint}/${record[primaryKey]}`);
                    }
              }
            >
              <EditOutlined style={{ color: "#1890ff" }} />
            </div>
          )}
          {isDelete && (
            <Popconfirm
              title="Мэдээллийг устгах уу?"
              onConfirm={deleteFunc ? () => deleteFunc(record) : () => handleDelete(record)}
              // onConfirm={() => handleDelete(record)}
              okText="Тийм"
              cancelText="Үгүй"
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Popconfirm>
          )}
        </div>
      );
    },
  };

  return (
    <>
      <Table
        scroll={{ x: true }}
        columns={actionCol ? [...tableColumns, actionCols] : tableColumns}
        dataSource={state.data}
        onChange={handleChange}
        key={Date.now()}
        pagination={
          pagination &&
          !resObj && {
            total: state.total,
            current: state.filter.Offset / state.filter.Limit + 1,
            pageSize: limit || state.filter.Limit,
            showTotal: (total) => ` Нийт бичлэг: ${total}`,
            showQuickJumper: true,
          }
        }
        bordered
        size="small"
        title={
          title || addFunc || rightBtn
            ? () => {
                return <TableHeader title={title} addUrl={isAdd && endpoint} addFunc={addFunc} rightBtn={rightBtn} />;
              }
            : null
        }
        {...props}
      />
      {spinner && state.loading && <Spinner />}
    </>
  );
}

export default CustomTable;
